
export default {
  name: "MainContentLoading"
}
